export default [
  {
    id: 1,
    content: '누전차단기의 정상 동작여부',
    isChecked: ''
  },
  {
    id: 2,
    content: '전기배선 불량 및 문어발식 콘센트 사용여부',
    isChecked: ''
  },
  {
    id: 3,
    content: '전기기구 접지 및 피뢰침 설치여부',
    isChecked: ''
  },
  {
    id: 4,
    content: '전기실 누유, 누전 및 보호시설 적정여부',
    isChecked: ''
  },
];
